export default "__VITE_ASSET__efe73269__"